import MapsInsight from "../../../../components/DataCollection/Unifier/Maps/MapsInsight/MapsInsight"

const MapsInsightScreen = () => {
  return (
    <>
      <MapsInsight />
    </>
  )
}

export default MapsInsightScreen
